import Tracking from "./tracking";

export interface ShareLinkOptions {
	shareTitle?: string;
	shareText?: string;
	trackingCategory: string;
	trackingMedium: string;
	trackingContent: string;
	trackingAction?: string;
	trackingLabel?: string;
	tooltipSelector?: string;
	shareId?: string;
}

export default class ShareLink {

	private shareTitle: string;
	private shareText: string;
	private trackingCategory: string;
	private trackingMedium: string;
	private trackingContent: string;
	private shareId?: string;
	private tooltipSelector: string;

	constructor(options: ShareLinkOptions) {
		this.shareTitle = options.shareTitle;
		this.shareText = options.shareText;
		this.trackingCategory = options.trackingCategory;
		this.trackingMedium = options.trackingMedium;
		this.trackingContent = options.trackingContent;
		this.shareId = options.shareId;
		this.tooltipSelector = options.tooltipSelector;
	}

	public async shareUrl(url: string, inputField: HTMLInputElement, skipTrackingUpdate: boolean = false) {
		if (!url) return;
		let trackedUrl = url;
		if (!skipTrackingUpdate) {
			try {
				trackedUrl = Tracking.addCampaignTracking(url, this.trackingCategory, this.trackingMedium, this.trackingContent, this.shareId);
			} catch {}

			if (inputField) {
				inputField.value = trackedUrl;
			}
		}

		if (navigator.share) {
			await navigator.share({
				title: this.shareTitle,
				text: this.shareText,
				url: trackedUrl
			})
			.then(() => {
				Tracking.trackShare(this.trackingMedium, this.trackingContent, this.shareId);
			})
			.catch(() => {});
			return;
		} else {
			this.copyUrlText(inputField);
			Tracking.trackShare(this.trackingMedium, this.trackingContent, this.shareId);
		}
	}

	private copyUrlText(inputField: HTMLInputElement) {
		let input = inputField;
		input.select();
		input.setSelectionRange(0, 99999);
		navigator.clipboard.writeText(input.value);

		if (!this.tooltipSelector) return;
		this.showTooltip('Link copied');
	}

	private showTooltip(message: string) {
		const tooltip = document.querySelector(this.tooltipSelector) as HTMLDivElement | null;
		if (!tooltip) return;
		tooltip.textContent = message;
		tooltip.setAttribute('aria-hidden', 'false');
		tooltip.setAttribute('role', 'alert');
		setTimeout(() => {
			document.addEventListener('click', () => {
				tooltip.setAttribute('aria-hidden', 'true');
			}, { once: true });
		}, 0);
	}
}

